import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Team from "./components/Team/Team"
import Research from "./components/Research/Research"
import Publications from "./components/Publications/Publications";
import MyGallery from "./components/Gallery/Gallery";
import PageNotFound from "./components/404";
import ContactPage from "./components/Contact/Contact";
import News from "./components/News/News";

import MemberPage from "./components/Team/MemberPage";
import members from "./data/members";
import Jobs from "./components/Jobs/Jobs";


function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
      <Router>
        {/*<Preloader load={load} />*/}
        <div className="App" id={load ? "no-scroll" : "scroll"}>
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/team" element={<Team />} />
            <Route path="/research" element={<Research />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/gallery" element={<MyGallery />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<ContactPage />} />
            {members.filter((member) => member.path !== "/").map((member) => (
                <Route key={member.id} path={member.path} element={<MemberPage member={member} />} />
            ))}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
  );
}

export default App;
